





























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Ref } from "vue-property-decorator";
import { Colors, notify } from "@/modules/core/notification";
import { VForm } from "@/types";
import { State } from "vuex-class";
import User from "@/modules/user/model/User";
import colors from "vuetify/es5/util/colors";

/**
 * Muestra un dialogo para cambiar la contraseña del usuario actualmente seleccionado
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PasswordChange extends Vue {
  /**
   * Referencia al formulario en la plantilla. Usada para la validación de campos
   */
  @Ref("form")
  public form: VForm;

  /**
   * Controla la visibilidad del dialogo
   */
  @Prop({ type: Boolean, default: false })
  public value: boolean;

  /**
   * Usuario actualmente seleccionado
   */
  @State((state) => state.user.currentUser)
  public user: User;

  public newPassword = "";
  public newPasswordConfirm = "";
  public clearSessions = true;
  public changingPassword = false;
  public passwordChangeIsValid = false;

  /**
   * Reglas de validación para los campos
   */
  public validationRules = {
    password: [
      (v: string) => !!v || "La nueva contraseña no puede estar vacía",
    ],
    passwordConfirm: [
      (v: string) => !!v || "La confirmación de contraseña es obligatoria",
    ],
  };

  /**
   * Cambia la contraseña del usuario actual
   */
  public async changePassword() {
    if (!this.form.validate()) {
      return;
    }

    this.changingPassword = true;
    try {
      await this.$store.dispatch("user/changeUserPassword", {
        password: this.newPassword,
        confirm: this.newPasswordConfirm,
        clearSessions: this.clearSessions,
      });
      this.$emit("input", false);
      this.form.reset();
      notify(
        `La contraseña del usuario ${this.user.id} se ha modificado correctamente`
      );
    } catch (e) {
      notify(
        `Error, La contraseña del usuario ${this.user.id} no se ha modificado correctamente.`,
        Colors.Error
      );
    }

    this.changingPassword = false;
    this.newPassword = "";
    this.newPasswordConfirm = "";
  }
}
